import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle } from 'lucide-react';
const EPISODES = [{
  num: '141',
  title: 'The Economics of a Sold-Out Arena',
  guest: 'Dr. Amanda Chen, Venue Strategy at AEG',
  duration: '58m',
  date: 'Oct 17, 2023'
}, {
  num: '140',
  title: 'Building a Sports Brand in a Saturated Market',
  guest: 'James Wilson, Founder of Six Five Sports',
  duration: '1h 12m',
  date: 'Oct 10, 2023'
}, {
  num: '139',
  title: 'The Future of Team-Owned Media',
  guest: 'Sarah Jenkins, Former Head of Content at the LA Rams',
  duration: '1h 05m',
  date: 'Oct 3, 2023'
}, {
  num: '138',
  title: 'Why Owning a Pro Team is Harder Than It Looks',
  guest: 'Marcus Chen, Sports Banker',
  duration: '1h 20m',
  date: 'Sep 26, 2023'
}, {
  num: '137',
  title: 'The Athlete Economy is Just Getting Started',
  guest: 'Elena Rostova, NIL Agent',
  duration: '55m',
  date: 'Sep 19, 2023'
}];
export function PodcastList() {
  return <section id="podcast" className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 border-thick-b" data-id="element-173">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-174">
        <div data-id="element-175">
          <span className="kicker-block mb-6" data-id="element-176">The Skybox Podcast</span>
          <h2 className="font-serif text-6xl sm:text-8xl lg:text-9xl font-black tracking-tighter uppercase leading-none" data-id="element-177">
            Episodes
          </h2>
        </div>
        <a href="#" className="font-mono text-base font-black uppercase tracking-widest text-ink hover:text-accent transition-colors border-b-4 border-ink hover:border-accent pb-1 inline-block self-start md:self-auto mb-2" data-id="element-178">
          All Episodes →
        </a>
      </div>

      <div className="border-t-4 border-ink" data-id="element-179">
        {EPISODES.map((ep, index) => <motion.div key={ep.num} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="group flex flex-col sm:flex-row sm:items-center py-8 sm:py-10 border-b-4 border-ink hover:bg-ink hover:text-cream transition-colors cursor-pointer px-4 -mx-4 sm:mx-0 sm:px-6" data-id="element-180">
            <div className="font-mono text-6xl sm:text-7xl font-black text-ink/20 group-hover:text-cream/20 w-32 shrink-0 mb-4 sm:mb-0 tracking-tighter" data-id="element-181">
              {ep.num}
            </div>

            <div className="flex-grow pr-6" data-id="element-182">
              <h3 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-black mb-3 group-hover:text-accent transition-colors leading-[0.9] tracking-tight" data-id="element-183">
                {ep.title}
              </h3>
              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 font-mono text-sm uppercase tracking-widest text-ink/70 group-hover:text-cream/70" data-id="element-184">
                <span className="font-black text-ink group-hover:text-cream" data-id="element-185">
                  W/ {ep.guest}
                </span>
                <span className="font-black" data-id="element-186">/</span>
                <span className="font-bold" data-id="element-187">{ep.date}</span>
                <span className="hidden sm:inline font-black" data-id="element-188">/</span>
                <span className="hidden sm:inline font-bold" data-id="element-189">
                  {ep.duration}
                </span>
              </div>
            </div>

            <div className="hidden sm:flex items-center justify-end w-16 shrink-0" data-id="element-190">
              <PlayCircle className="w-12 h-12 text-ink group-hover:text-accent transition-colors" data-id="element-191" />
            </div>
          </motion.div>)}
      </div>
    </section>;
}